module.exports = __webpack_public_path__ + "img/6.5bc95dd8.jpg";